export const offices = [
    {
        "ID": "D",
        "NAME": "Edeljungfrau"
    },
    {
        "ID": "E",
        "NAME": "Edelknabe"
    },
    {
        "ID": "Fs",
        "NAME": "Vorschneider"
    },
    {
        "ID": "GR",
        "NAME": "Geheimer Rat"
    },
    {
        "ID": "H",
        "NAME": "Hofdiener"
    },
    {
        "ID": "H0",
        "NAME": "Hofdiener (ohne Besoldung)"
    },
    {
        "ID": "H1",
        "NAME": "Hofdiener (auf 1 Pferd)"
    },
    {
        "ID": "H2",
        "NAME": "Hofdiener (auf 2 Pferden)"
    },
    {
        "ID": "H3",
        "NAME": "Hofdiener (auf 3 und mehr Pferden)"
    },
    {
        "ID": "HarHM",
        "NAME": "Hartschierhauptmann"
    },
    {
        "ID": "HB",
        "NAME": "Hofbuchhalter"
    },
    {
        "ID": "HC",
        "NAME": "Hofkanzler"
    },
    {
        "ID": "HCSek",
        "NAME": "Hofsekret\u00e4r"
    },
    {
        "ID": "HCSekBG",
        "NAME": "Hofsekret\u00e4r (burgundischer Expedition)"
    },
    {
        "ID": "HCSekBO",
        "NAME": "Hofsekret\u00e4r (deutscher Expedition f\u00fcr B\u00f6hmen)"
    },
    {
        "ID": "HCSekCZ",
        "NAME": "Hofsekret\u00e4r (b\u00f6hmischer Expedition)"
    },
    {
        "ID": "HCSekES",
        "NAME": "Hofsekret\u00e4r (spanischer Expedition)"
    },
    {
        "ID": "HCSekHU",
        "NAME": "Hofsekret\u00e4r (ungarischer Expedition)"
    },
    {
        "ID": "HCSekLA",
        "NAME": "Hofsekret\u00e4r (lateinischer Expedition)"
    },
    {
        "ID": "HCSekLS",
        "NAME": "Hofsekret\u00e4r (f\u00fcr Lausitz)"
    },
    {
        "ID": "HCSekSL",
        "NAME": "Hofsekret\u00e4r (f\u00fcr Schlesien)"
    },
    {
        "ID": "HKaD",
        "NAME": "Hofkammerdiener"
    },
    {
        "ID": "HKaKon",
        "NAME": "Hofkammerkonzipist"
    },
    {
        "ID": "HKaP",
        "NAME": "Hofkammerpr\u00e4sident"
    },
    {
        "ID": "HKaPX",
        "NAME": "Hofkammerpr\u00e4sident (Amtsverwalter)"
    },
    {
        "ID": "HKaR",
        "NAME": "Hofkammerrat"
    },
    {
        "ID": "HKaReg",
        "NAME": "Hofkammerregistrator"
    },
    {
        "ID": "HKaRegA",
        "NAME": "Hofkammerregistrator (Adjunkt)"
    },
    {
        "ID": "HKaSek",
        "NAME": "Hofkammersekret\u00e4r"
    },
    {
        "ID": "HKaSekU",
        "NAME": "Hofkammeruntersekret\u00e4r"
    },
    {
        "ID": "HKaVP",
        "NAME": "Hofkammervizepr\u00e4sident"
    },
    {
        "ID": "HKrOMM",
        "NAME": "Oberstmustermeister"
    },
    {
        "ID": "HKrP",
        "NAME": "Hofkriegsratspr\u00e4sident"
    },
    {
        "ID": "HKrQM",
        "NAME": "Hofquartiermeister"
    },
    {
        "ID": "HKrR",
        "NAME": "Hofkriegsrat"
    },
    {
        "ID": "HKrSek",
        "NAME": "Hofkriegsratssekret\u00e4r"
    },
    {
        "ID": "HKrUMM",
        "NAME": "Untermustermeister"
    },
    {
        "ID": "HKrVP",
        "NAME": "Hofkriegsratsvizepr\u00e4sident"
    },
    {
        "ID": "HKrZM",
        "NAME": "Hofkriegszahlmeister"
    },
    {
        "ID": "HKt",
        "NAME": "Hofkontrolleur"
    },
    {
        "ID": "HPfenM",
        "NAME": "Hofpfennigmeister"
    },
    {
        "ID": "HPostM",
        "NAME": "Hofpostmeister"
    },
    {
        "ID": "HPostMX",
        "NAME": "Hofpostmeister (Amtsverwalter)"
    },
    {
        "ID": "HR",
        "NAME": "Hofrat"
    },
    {
        "ID": "Hs",
        "NAME": "Huschier"
    },
    {
        "ID": "HVC",
        "NAME": "Hofvizekanzler"
    },
    {
        "ID": "HZKt",
        "NAME": "Hofzahlamtskontrolleur"
    },
    {
        "ID": "HZM",
        "NAME": "Hofzahlmeister"
    },
    {
        "ID": "K",
        "NAME": "K\u00e4mmerer"
    },
    {
        "ID": "K0",
        "NAME": "K\u00e4mmerer (unwirklich)"
    },
    {
        "ID": "Kd",
        "NAME": "Kammerdiener"
    },
    {
        "ID": "Lwin",
        "NAME": "Leibwarterin"
    },
    {
        "ID": "Math",
        "NAME": "Hofmathematiker"
    },
    {
        "ID": "Med",
        "NAME": "Hofarzt"
    },
    {
        "ID": "Ms",
        "NAME": "Mundschenk"
    },
    {
        "ID": "OFalkM",
        "NAME": "Oberstfalkenmeister"
    },
    {
        "ID": "OHM",
        "NAME": "Obersthofmeister"
    },
    {
        "ID": "OHMar",
        "NAME": "Obersthofmarschall"
    },
    {
        "ID": "OHMin",
        "NAME": "Obersthofmeisterin"
    },
    {
        "ID": "OHMX",
        "NAME": "Obersthofmeister (Amtsverwalter)"
    },
    {
        "ID": "OJM",
        "NAME": "Oberstj\u00e4germeister"
    },
    {
        "ID": "OK",
        "NAME": "Oberstk\u00e4mmerer"
    },
    {
        "ID": "OK\u00fcM",
        "NAME": "Oberstk\u00fcchenmeister"
    },
    {
        "ID": "OSilK",
        "NAME": "Oberstsilberk\u00e4mmerer"
    },
    {
        "ID": "OSilKX",
        "NAME": "Oberstsilberk\u00e4mmerer (Amtsverwalter)"
    },
    {
        "ID": "OStallM",
        "NAME": "Oberststallmeister"
    },
    {
        "ID": "OTs",
        "NAME": "St\u00e4belmeister"
    },
    {
        "ID": "OTsU",
        "NAME": "Unterst\u00e4belmeister"
    },
    {
        "ID": "Pt",
        "NAME": "Panetier"
    },
    {
        "ID": "R",
        "NAME": "Rat"
    },
    {
        "ID": "RCSek",
        "NAME": "Reichskanzleisekret\u00e4r"
    },
    {
        "ID": "RHF",
        "NAME": "Reichshoffiskal"
    },
    {
        "ID": "RHP",
        "NAME": "Reichshofratspr\u00e4sident"
    },
    {
        "ID": "RHR",
        "NAME": "Reichshofrat"
    },
    {
        "ID": "RHSek",
        "NAME": "Reichshofratssekret\u00e4r"
    },
    {
        "ID": "RHVP",
        "NAME": "Reichshofratsvizepr\u00e4sident"
    },
    {
        "ID": "SM",
        "NAME": "Schatzmeister"
    },
    {
        "ID": "So",
        "NAME": "Sommelier"
    },
    {
        "ID": "TraHM",
        "NAME": "Trabantenhauptmann"
    },
    {
        "ID": "Ts",
        "NAME": "Truchsess"
    },
    {
        "ID": "UHMar",
        "NAME": "Untermarschall"
    },
    {
        "ID": "USilK",
        "NAME": "Untersilberk\u00e4mmerer"
    },
    {
        "ID": "VJ",
        "NAME": "Vogelj\u00e4ger"
    }
]
